import debounce from 'lodash/debounce';
import handleIndexIncrementation from './handleIndexIncrementation';
import handleLoad from './handleLoad';
import handlePagination from './handlePagination';
import setCurrentSelectedLanguage from './setCurrentSelectedLanguage';

/**
 * Attach interactions to every element that matches selector.
 */
$('.downloads-list').each((_, component) => {
    $(component).data('results', []); // will be filled by load handler

    const delay = $(component).attr('data-request-delay');
    const $itemTemplate = $(component).find('.downloads__item[data-template]')
        .removeAttr('data-template')
        .detach();
    const $selectItemTemplate = $(component).find('.downloads-list__lang .select__item')
        .first()
        .detach();
    $(component).find('.downloads-list__type .select__item')
        .first().remove();

    $(component)
        .on('input', '.downloads-list__search', debounce(
            handleLoad(component, $itemTemplate, $selectItemTemplate),
            delay
        ))
        .on('change', '.select', handlePagination(component, $itemTemplate, true))
        .on('click', '.loader', handleIndexIncrementation(component))
        .on('click', '.loader', handlePagination(component, $itemTemplate));

    $(window).on('load', handleLoad(component, $itemTemplate, $selectItemTemplate));
    $(window).on('load', setCurrentSelectedLanguage($));
});



// WEBPACK FOOTER //
// ./src/scripts/components/downloads-list/index.js